module.exports = __webpack_public_path__ + "cf7c8f35c8bffa25bc3e713775dd538a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/turkey.png
 ** module id = 679
 ** module chunks = 0
 **/